import { Turbo } from "@hotwired/turbo-rails"

// Full-page Turbo Drive is disabled, so Turbo does not see every form submission.
// Confirm at the DOM boundary for both native and Turbo submissions.
const confirmedForms = new WeakSet()

document.addEventListener("submit", (event) => {
  const form = event.target
  const message = event.submitter?.getAttribute("data-turbo-confirm") || form.getAttribute("data-turbo-confirm")
  if (!message) return

  if (!window.confirm(message)) {
    event.preventDefault()
    event.stopImmediatePropagation()
    return
  }

  confirmedForms.add(form)
}, true)

// Turbo calls this after the submit event. A form already approved above must
// not show a second dialog; direct Turbo submissions still get a confirmation.
Turbo.config.forms.confirm = (message, form) => {
  if (confirmedForms.has(form)) {
    confirmedForms.delete(form)
    return true
  }

  return window.confirm(message)
}

document.addEventListener("click", (event) => {
  const link = event.target.closest?.("a[data-turbo-confirm]:not([data-turbo-method])")
  if (link && !window.confirm(link.getAttribute("data-turbo-confirm"))) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }
}, true)
